export const formatDate = (date) => {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(amount);

export const warrantyStatus = (purchaseDate, durationMonths) => {
  const expiry = new Date(purchaseDate);
  expiry.setMonth(expiry.getMonth() + Number(durationMonths));
  return {
    status: new Date() <= expiry ? "Active" : "Expired",
    expiryDate: expiry,
  };
};

export const durationOptions = [
  { label: "3 Months", months: 3 },
  { label: "6 Months", months: 6 },
  { label: "1 Year", months: 12 },
  { label: "2 Years", months: 24 },
  { label: "3 Years", months: 36 },
  { label: "5 Years", months: 60 },
];
